import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { Onboarding1099 } from "../SignUp/screens/1099Onboarding";
import {
  DashboardScope,
  NEC1099FilingDashboard
} from "./screens/NEC1099FilingDashboard";
import { NEC1099FilingDashboardPreview } from "./screens/NEC1099FilingDashboardPreview";
import { Setup1099 } from "./screens/Setup1099";

export const NEC1099Filing = () => {
  const history = useHistory();
  return (
    <Switch>
      <Route
        path="/member/1099-filing/onboarding"
        render={() => (
          <Onboarding1099
            basePath="/member/1099-filing/onboarding"
            onBack={() => {
              // there is no going back from this
            }}
            onFinish={() => {
              history.push("/member/benefits");
            }}
          />
        )}
      />

      <Route
        path="/member/1099-filing/set-up"
        render={() => (
          <Setup1099
            basePath="/member/1099-filing/set-up"
            onBack={() => {
              history.push("/member/1099-filing/preview");
            }}
            onFinish={() => {
              history.push(
                `/member/1099-filing/dashboard/${DashboardScope.All}`
              );
            }}
          />
        )}
      />

      <Route
        path="/member/1099-filing/preview"
        render={() => {
          return <NEC1099FilingDashboardPreview />;
        }}
      />

      <Route
        path={"/member/1099-filing/dashboard/:scope"}
        component={NEC1099FilingDashboard}
      />

      <Redirect
        from="/member/1099-filing/dashboard"
        to={`/member/1099-filing/dashboard/${DashboardScope.All}`}
        exact
      />
    </Switch>
  );
};
